export function isValidEmail(val: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
}

export function isValidPhone(val: string): boolean {
  const trimmed = val.trim();
  const digitsOnly = trimmed.replace(/\D/g, '');

  return (
    /^[+]?[\d\s-]{9,18}$/.test(trimmed) &&
    digitsOnly.length >= 9 &&
    digitsOnly.length <= 15
  );
}
